var React = require('react');

function ChevronIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.53553391 11.0355339-5.07106782-5.07106781 5.07106782-5","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"2.2","transform":"matrix(-1 0 0 -1 10 13)"}));
}

ChevronIcon.defaultProps = {"height":"14","viewBox":"0 0 14 14","width":"14"};

module.exports = ChevronIcon;

ChevronIcon.default = ChevronIcon;
